import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FaCommentDollar, FaRegIdBadge } from 'react-icons/fa';
import Modal from 'react-modal';
import WrappedIntlComponent from '../../../../common/intl/WrappedIntlComponent';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../helpers/Fields/InputField';
import { numericality, required } from 'redux-form-validators';
import { createUserTransaction } from '../../actions';
import InputFieldFile from '../../../../helpers/Fields/InputFieldFile';
import {toastr} from 'react-redux-toastr'
import Spiner from '../../../../helpers/Spiner/Spiner';
export class NewTransaction extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      spinner: false
    }
  }


  submit = async (data) => {
    const {formatMessage, reset} = this.props;

    try {
      this.setState({spinner: true})
      const res = await createUserTransaction({...data, user_id: this.props.user_id});
      toastr.success(formatMessage('transactionSuccessTitle'), formatMessage('transactionSuccessMsg'));
      this.setState({isOpen: false, spinner: false})
      reset()
    } catch (error) {
      this.setState({spinner: false})
      toastr.error(formatMessage('transactionErrorTitle'), formatMessage('transactionErrorMsg'));
    }
  }


  render() {
    const {formatMessage, handleSubmit} = this.props;
    const {isOpen, spinner} = this.state;
    return (
      <React.Fragment>
        <FaCommentDollar  onClick={() => {this.setState({isOpen: true})}} className={'icon'}/>
        <Modal
          isOpen = {isOpen}
          style = {{
              overlay : {
                zIndex: 999999
              },
          }}
          overlayClassName = "custom-modal payment-paypal-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('newTransaction')}</div>
          </div>
          <div className="create-dialog-modal-content__body" style={{padding: '5px 20px 0px'}}>
            <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)} style={{position: 'relative'}}>
              {spinner && <div style={{
                position: 'absolute', 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: 'rgba(255,255,255, 0.5)',
              }}>
                <Spiner/>
              </div>}
              <Field
                name="amount"
                label={formatMessage('titleTrAmount')}
                component={InputField}
                validate={[required(), numericality({ int: true })]}
              />
              <Field
                name="months"
                label={formatMessage('titleTrMonths')}
                component={InputField}
                validate={[required(), numericality({ int: true })]}
              />
              <Field
                name="promo_code"
                label={formatMessage('titleTrPromoCode')}
                component={InputField}
              />
              <Field
                name="procent"
                label={formatMessage('titleTrProcent')}
                component={InputField}
                validate={[numericality({ int: true, '>=': 0, '<=': 100 })]}
              />
              <Field
                name="transaction_id"
                label={formatMessage('titleTrTransactionId')}
                component={InputField}
              />
              <Field
                name="UploadFiles"
                label={formatMessage('titleTrFile')}
                component={InputFieldFile}
              />
              <div className="actions" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 40}}>
                <button
                    className="btn btn-primary"
                    type="submit"
                >{formatMessage('btnTransactionTitleNew')}</button>
                <button
                    className="btn btn-danger"
                    style={{marginLeft: 10}}
                    type="button"
                    onClick={() => {
                      this.setState({isOpen: false});
                      
                    }}
                  >{formatMessage('btnTransactionTitleCancel')}</button>
              </div>
            </form>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

NewTransaction = reduxForm({
  form: 'transaction_form'
})(NewTransaction)

export default WrappedIntlComponent(NewTransaction);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/components/NewTransaction/NewTransaction.jsx